/**
 * Validates that critical environment variables are set at app startup.
 * Logs warnings for missing optional vars; throws for critical ones.
 */
export const validateEnv = () => {
  const required = [
    'VITE_SUPABASE_URL',
    'VITE_SUPABASE_PUBLISHABLE_KEY',
  ] as const;

  const optional = [
    'VITE_SITE_URL',
    'VITE_SENTRY_DSN',
    'VITE_GA_MEASUREMENT_ID',
  ] as const;

  const missing: string[] = [];

  for (const key of required) {
    if (!import.meta.env[key]) {
      missing.push(key);
    }
  }

  if (missing.length > 0) {
    console.error(
      `[Hostel Hunters] Missing critical environment variables: ${missing.join(', ')}. The app may not function correctly.`
    );
  }

  for (const key of optional) {
    if (!import.meta.env[key]) {
      console.warn(`[Hostel Hunters] Optional env var ${key} is not set.`);
    }
  }
};
